import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './JobEventList.m.sass';
import EventCategoryDropdown from '../EventCategoryDropdown';
import EventItem from './EventItem';
import EmptyState from '../../../../components/EmptyState';
import InfiniteScrollZone from '../../../../components/InfiniteScrollZone';
import ContentLoading from '../../../../components/ContentLoading';
var empty = /*#__PURE__*/React.createElement(EmptyState, {
  title: "No events to show."
});
var JobEventList = function JobEventList(_ref) {
  var events = _ref.events,
    onCategoryChange = _ref.onCategoryChange,
    _ref$category = _ref.category,
    category = _ref$category === void 0 ? 'ALL' : _ref$category,
    scrollProvider = _ref.scrollProvider;
  events = category === 'ALL' ? events : events.filter(function (x) {
    return x.eventCategory === category;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, onCategoryChange && /*#__PURE__*/React.createElement("div", {
    className: styles.controls
  }, /*#__PURE__*/React.createElement(EventCategoryDropdown, {
    value: category,
    onChange: onCategoryChange
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.list
  }, events.length === 0 ? empty : events.map(function (event) {
    return /*#__PURE__*/React.createElement(EventItem, {
      event: event,
      key: event.id
    });
  }), scrollProvider && /*#__PURE__*/React.createElement(InfiniteScrollZone, {
    scrollProvider: scrollProvider
  }, function (_ref2) {
    var isDone = _ref2.isDone,
      active = _ref2.active;
    return !isDone && /*#__PURE__*/React.createElement(ContentLoading, {
      smaller: true
    });
  })));
};
export default observer(JobEventList);
//# sourceMappingURL=index.js.map
